import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { NonprofitFeatureFlag } from './models';

/**
 * State for the submitting a support request.
 */
@RegisterYCState()
export class NonprofitFeatureFlagsState extends BaseYcState {
  readonly nonprofitFeatureFlags: NonprofitFeatureFlag[];
}
